exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table[data-v-f488ec6a] {\n  background-color: white;\n  width: 100%;\n  border: 1px solid #dee2e6;\n  border-radius: 8px;\n  border-collapse: separate;\n}\n.table__row td[data-v-f488ec6a], th[data-v-f488ec6a] {\n  border: none;\n  padding: 0.75rem;\n  border-bottom: 1px solid #dee2e6;\n}\n.table .table__row:last-child > td[data-v-f488ec6a] {\n  border-bottom: none;\n}\n.bottom-buttons[data-v-f488ec6a] {\n  text-align: right;\n}\n@media (max-width: 767px) {\n.bottom-buttons[data-v-f488ec6a] {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n    text-align: center;\n}\n}", ""]);

// exports
